/**
 * Shared helpers for client list/detail/create/edit.
 * API uses client_type: 'single' | 'multiple'; UI shows "Individual" | "Corporate client".
 */

export function clientTypeLabel(clientType: string | null | undefined): string {
  if (clientType === 'multiple') return 'Corporate client';
  if (clientType === 'single') return 'Individual';
  return '—';
}

/** Display name for title/avatar: company name or client name */
export function clientDisplayName(row: { company_name?: string | null; name?: string | null } | null | undefined): string {
  if (!row) return '';
  return (row.company_name ?? row.name ?? '').trim() || '—';
}

/** Two-letter initials from company name or name (e.g. "Chikale Foods" -> "CF") */
export function clientAvatarInitials(row: { company_name?: string | null; name?: string | null } | null | undefined): string {
  const name = clientDisplayName(row);
  if (!name || name === '—') return '?';
  const words = name.split(/\s+/).filter(Boolean);
  if (words.length >= 2) {
    const a = words[0].slice(0, 1);
    const b = words[1].slice(0, 1);
    return (a + b).toUpperCase();
  }
  return name.slice(0, 2).toUpperCase();
}
